import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-661b08cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-item-box" }
const _hoisted_2 = { class: "list-item-header" }
const _hoisted_3 = { class: "list-item-left-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-tag-box" }, null, -1))
const _hoisted_8 = { class: "operation-btn" }
const _hoisted_9 = { class: "list-item-body-table" }
const _hoisted_10 = { class: "table-row01" }
const _hoisted_11 = ["rowspan"]
const _hoisted_12 = {
  class: "align-left-box",
  style: {"padding":"10px"}
}
const _hoisted_13 = ["rowspan"]
const _hoisted_14 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_15 = ["rowspan"]
const _hoisted_16 = { class: "ext-message-box" }
const _hoisted_17 = { class: "address-box" }
const _hoisted_18 = ["rowspan"]
const _hoisted_19 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_20 = ["rowspan"]
const _hoisted_21 = {
  class: "align-left-box",
  style: {"padding":"0 5px"}
}
const _hoisted_22 = ["rowspan"]
const _hoisted_23 = { class: "align-right-box" }
const _hoisted_24 = {
  key: 0,
  class: "pack-list-box"
}
const _hoisted_25 = { class: "pack-title-box" }
const _hoisted_26 = { class: "pack-tag" }
const _hoisted_27 = {
  key: 0,
  class: "line-tag-box"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 2,
  class: "line-tag-box"
}
const _hoisted_30 = { key: 3 }
const _hoisted_31 = {
  key: 4,
  class: "line-tag-box"
}
const _hoisted_32 = { key: 5 }
const _hoisted_33 = { class: "pack-operat-box" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  class: "canceled-tag"
}
const _hoisted_37 = {
  key: 0,
  class: "pack-row-box"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品：", -1))
const _hoisted_39 = {
  key: 0,
  class: "pack-row-box"
}
const _hoisted_40 = {
  key: 0,
  class: "pack-addr"
}
const _hoisted_41 = {
  key: 1,
  class: "pack-row-box"
}
const _hoisted_42 = {
  key: 0,
  class: "pack-addr"
}
const _hoisted_43 = {
  key: 2,
  class: "pack-row-box"
}
const _hoisted_44 = {
  key: 1,
  class: "buy-remake-box remake-box"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "买家留言：", -1))
const _hoisted_46 = {
  key: 2,
  class: "remake-box"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卖家备注：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoodsItem = _resolveComponent("GoodsItem")!
  const _component_ApplicationItem = _resolveComponent("ApplicationItem")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, "订单号：" + _toDisplayString(_ctx.modelValue.orderNumber), 1),
        _hoisted_4,
        _createElementVNode("div", null, "下单时间：" + _toDisplayString(_ctx.$format(_ctx.modelValue.createTime)), 1),
        _hoisted_5,
        _createElementVNode("div", null, "付款方式：" + _toDisplayString(_ctx.payType), 1),
        _hoisted_6,
        _createElementVNode("div", null, "订单状态：" + _toDisplayString(_ctx.orderStatus), 1),
        (_ctx.couponText)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_7,
              _createElementVNode("div", null, "优惠券：" + _toDisplayString(_ctx.couponText), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.hidePayList)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "operat-tag-box",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoDetail && _ctx.gotoDetail(...args)))
            }, "详情"))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "operat-tag-box",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remake && _ctx.remake(...args)))
        }, "备注")
      ])
    ]),
    _createElementVNode("table", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.orderGoods, (item, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          _createElementVNode("td", _hoisted_10, [
            _createVNode(_component_GoodsItem, { modelValue: item }, null, 8, ["modelValue"])
          ]),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: "table-row02",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.applicationList, (item, i) => {
                    return (_openBlock(), _createBlock(_component_ApplicationItem, {
                      modelValue: item,
                      key: i,
                      onRefresh: _ctx.refresh
                    }, null, 8, ["modelValue", "onRefresh"]))
                  }), 128)),
                  (_ctx.modelValue.status == 1 || _ctx.modelValue.status == 2)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 0,
                        style: {"margin-top":"10px"},
                        onClick: _ctx.returnGoods
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("退款")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_11))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 1,
                class: "table-row03",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.showAmount), 1)
              ], 8, _hoisted_13))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 2,
                class: "table-row04",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, "买家：" + _toDisplayString(_ctx.buyerName) + " " + _toDisplayString(_ctx.buyerMobile), 1),
                  _createElementVNode("div", null, "收货人：" + _toDisplayString(_ctx.modelValue.username) + " " + _toDisplayString(_ctx.modelValue.mobile), 1),
                  _createElementVNode("div", _hoisted_17, "收货地址：" + _toDisplayString(_ctx.fullAddress), 1),
                  (_ctx.modelValue.extMessage)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.modelValue.extMessage, (item) => {
                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item.name) + " : " + _toDisplayString(item.value), 1))
                      }), 256))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_15))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 3,
                class: "table-row05",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.expressType), 1)
              ], 8, _hoisted_18))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 4,
                class: "table-row06",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.orderStatus), 1)
              ], 8, _hoisted_20))
            : _createCommentVNode("", true),
          (i == 0)
            ? (_openBlock(), _createElementBlock("td", {
                key: 5,
                class: "table-row07",
                rowspan: _ctx.modelValue.orderGoods.length
              }, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.modelValue.status == 0)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 0,
                        onClick: _ctx.modifyPrice
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("改价")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.modelValue.status == 1)
                    ? (_openBlock(), _createBlock(_component_ui_button, {
                        key: 1,
                        onClick: _ctx.sendGoods
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发货")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_22))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.modelValue.packList && _ctx.modelValue.packList.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue.packList, (pack, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["pack-item-box", { canceled: pack.isCancel }]),
              key: pack.id
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, "包裹" + _toDisplayString(index + 1), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.packType(pack.type)), 1),
                (pack.orderNumber)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                  : _createCommentVNode("", true),
                (pack.orderNumber)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, "包裹单号：" + _toDisplayString(pack.orderNumber), 1))
                  : _createCommentVNode("", true),
                (_ctx.expressName(pack.expressId))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                  : _createCommentVNode("", true),
                (_ctx.expressName(pack.expressId))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.expressName(pack.expressId)), 1))
                  : _createCommentVNode("", true),
                (pack.expressBill)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                  : _createCommentVNode("", true),
                (pack.expressBill)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "运单号：" + _toDisplayString(pack.expressBill), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  (pack.type == 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "track-pack-btn",
                        onClick: ($event: any) => (_ctx.viewPackTrack(pack))
                      }, "轨迹查询", 8, _hoisted_34))
                    : _createCommentVNode("", true),
                  (!pack.isCancel)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "cancel-pack-btn",
                        onClick: ($event: any) => (_ctx.cancelPack(pack))
                      }, "取消包裹", 8, _hoisted_35))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, "已取消"))
                ])
              ]),
              ((pack.goodsItemList || []).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _hoisted_38,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pack.goodsItemList, (item, gi) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: item.id
                      }, [
                        _createTextVNode(_toDisplayString(item.name) + " × " + _toDisplayString(item.num), 1),
                        (gi < pack.goodsItemList.length - 1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("、")
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!pack.isCancel)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (pack.senderName || pack.senderMobile || _ctx.senderAddress(pack))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("span", null, "发货人：" + _toDisplayString(pack.senderName) + " " + _toDisplayString(pack.senderMobile), 1),
                          (_ctx.senderAddress(pack))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, "发货地址：" + _toDisplayString(_ctx.senderAddress(pack)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (pack.receiverName || pack.receiverMobile || _ctx.receiverAddress(pack))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("span", null, "收货人：" + _toDisplayString(pack.receiverName) + " " + _toDisplayString(pack.receiverMobile), 1),
                          (_ctx.receiverAddress(pack))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, "收货地址：" + _toDisplayString(_ctx.receiverAddress(pack)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (pack.type == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createTextVNode(" 提交状态：" + _toDisplayString(_ctx.submitStatusText(pack.submitStatus)), 1),
                          (pack.submitTime)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("（" + _toDisplayString(_ctx.$format(pack.submitTime)) + "）", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.modelValue.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _hoisted_45,
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue.message), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modelValue.remake)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          _createTextVNode(" " + _toDisplayString(_ctx.modelValue.remake), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}